import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsMultiNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.536 9.685c.115.071.248.11.383.113H10.9h.033-.014a.79.79 0 00.682-.42l.43-.8a.138.138 0 01.051-.061.13.13 0 01.079-.02h1.67v-1H12.2a1.14 1.14 0 00-1 .61l-.24.45-1-1.94a.781.781 0 00-1.29-.146.798.798 0 00-.1.147l-.42.8a.159.159 0 01-.14.08H6.73v1h1.28a1.14 1.14 0 001-.61l.24-.45 1 1.94a.77.77 0 00.285.307z"
        fill=""
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.32 13.598l-.01-.043a5.68 5.68 0 10-.636-11.102 5.426 5.426 0 00-.853-.065 5.672 5.672 0 00-.882.106.518.518 0 00-.108-.036 6.245 6.245 0 00-1.22-.13 5.681 5.681 0 000 11.35 6.26 6.26 0 001.21-.07h.004c.325.071.658.116.996.13a5.75 5.75 0 001.5-.14zM2.453 4.79a4.679 4.679 0 012.246-1.307 5.681 5.681 0 00-.16 9.035 4.677 4.677 0 01-3.381-4.496c0-1.204.464-2.361 1.295-3.232zm2.453 5.325a5.68 5.68 0 002.05 2.518 4.679 4.679 0 01-.614-8.91 5.68 5.68 0 00-1.437 6.391zm2.653-6.064a4.678 4.678 0 012.603-.784 4.69 4.69 0 014.67 4.68 4.68 4.68 0 11-7.273-3.896z"
        fill=""
      />
    </svg>
  )
);
SvgSportsMultiNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsMultiNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsMultiNormalXsmall;
